import createVueApp from '../../shared/vue/create-app';
import shared from '../../shared';
import {initListingCardComponent} from '../../components/card/listing-card';
import initCustomControls from '../../components/custom-controls';
import initAutocompleteComponent from '../../components/map/autocomplete';
import openPreviewMixin from '../../shared/vue/openPreviewMixin';
import initCustomInputsComponents from '../../components/inputs/custom-inputs';
import initCollapseComponents from '../../components/collapse-controls';
import {landingEngageMixin} from '../../components/mixins/landing-mixins';
import initListingExtraDetailsComponent from '../../components/card/listing-extra-details';
import {initCurrencyPriceComponents} from '../../components/inputs/currency-price';
import initListingContactForm from '../../components/listing-contact-form';
import initFavoriteSwitchComponent from '../../components/favorite-switch';

const initCityLandingPage = (settings) => {
    const app = createVueApp({
        mixins: [openPreviewMixin, landingEngageMixin],
        created() {
            this.initEngageData(settings);
        },
    });

    initListingCardComponent(app);
    initCustomControls(app);
    initAutocompleteComponent(app);
    initCustomInputsComponents(app);
    initCollapseComponents(app);
    initListingExtraDetailsComponent(app);
    initCurrencyPriceComponents(app);
    initListingContactForm(app);
    initFavoriteSwitchComponent(app);

    app.mount('#app');

    return app;
};

export {shared, initCityLandingPage};
